import { ObjectBuilder } from "./object-builder";
import { ObjectBuilderWithIf } from "./object-builder-if";
import { PropertyBuilder } from "./property-builder";
import { Validator } from "./validator";
export function buildRules(propertyBuilders) {
    const validationRules = propertyBuilders.reduce((result, pb) => {
        const propertyName = pb.propertyName;
        const primitiveRules = pb._prmitiveRules || [];
        const rule = pb._objectRule ? Object.assign([...primitiveRules], { item: pb._objectRule })
            : pb._arrayRule ? Object.assign([...primitiveRules], { items: pb._arrayRule })
                : [...primitiveRules];
        //@ts-ignore
        result[propertyName] = rule;
        return result;
    }, {});
    return validationRules;
}
export class ValidationBuilder {
    constructor() {
        this.propertyBuilders = [];
        this.ifRules = [];
    }
    ensure(propertyName) {
        let propBuilder = this.propertyBuilders.find(pb => pb.propertyName === propertyName);
        if (propBuilder)
            return propBuilder;
        propBuilder = new PropertyBuilder(this, propertyName);
        this.propertyBuilders.push(propBuilder);
        return propBuilder;
    }
    if(condition) {
        const ifBuilder = new ValidationBuilderWithIf(this, condition, () => {
            const rules = ifBuilder.rules();
            this.ifRules.push([ifBuilder.condition, rules]);
        });
        return ifBuilder;
    }
    ensureSelf() {
        let objBuilder = new ObjectBuilder(this);
        if (!this.objectBuilder) {
            this.objectBuilder = objBuilder;
        }
        else {
            objBuilder = this.objectBuilder;
        }
        return objBuilder;
    }
    rules() {
        const validationRules = buildRules(this.propertyBuilders);
        validationRules.__if = this.ifRules;
        if (this.objectBuilder)
            validationRules.__self = this.objectBuilder._rules;
        return validationRules;
    }
    build() {
        const rules = this.rules();
        return new Validator(rules);
    }
}
export class ValidationBuilderWithIf {
    constructor(builder, condition, endIfCallback) {
        this.builder = builder;
        this.condition = condition;
        this.endIfCallback = endIfCallback;
        this.propertyBuilders = [];
    }
    ensure(propertyName) {
        let propBuilder = this.propertyBuilders.find(pb => pb.propertyName === propertyName);
        if (propBuilder)
            return propBuilder;
        propBuilder = new PropertyBuilder(this, propertyName);
        this.propertyBuilders.push(propBuilder);
        return propBuilder;
    }
    ensureSelf() {
        let objBuilder = new ObjectBuilderWithIf(this);
        if (!this.objectBuilder) {
            this.objectBuilder = objBuilder;
        }
        else {
            objBuilder = this.objectBuilder;
        }
        return objBuilder;
    }
    endIf() {
        this.endIfCallback();
        return this.builder;
    }
    rules() {
        const validationRules = buildRules(this.propertyBuilders);
        if (this.objectBuilder)
            validationRules.__self = this.objectBuilder._rules;
        return validationRules;
    }
    build() {
        const rules = this.rules();
        return new Validator(rules);
    }
}
